
<ng-container *ngIf="name != 'item de la liste'">
  <label>{{name}}</label>
</ng-container>
<select class="cell-status form-select" [formControl]="formControlNumber">
  <ng-container *ngIf="name != null"><option [value]=null hidden >Sélectionner un {{name | lowercase}}</option></ng-container>
  <option *ngFor="let parametre of listOfParametres()" [value]="parametre.id">{{parametre.libelle}}</option>
</select>
